if(navigator.userAgent.indexOf('Mac') > 0)
$('body').addClass('mac-os');

$(document).ready(function(){

  var email_pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  var temp = $('body').attr('temp');
  console.log(temp);

  var cookieCurrency = Currency.cookie.read();
  // First time load show price
  var cookie_curr = 'INR';
  if(cookieCurrency == 'USD'){
    cookie_curr = 'USD';  
  }
  var default_curr = 'INR';
  money(cookie_curr,default_curr);

  // currency picker symbol $ and RS
  $('header .currency-picker').removeClass('usd');
  if(cookieCurrency == 'USD' ){
    $('header .currency-picker').addClass('usd');
  }

  // currency picker
  $('header .currency-picker').change(function(){   
    var val = $(this).val();
    var default_selected = $(this).find("option.shop").text();
    var update_val = val.toLowerCase();    
    if(update_val == ('inr')){
      $('header .currency-picker').addClass('inr');
      $('header .currency-picker').removeClass('usd');
    }
    else{
      $('header .currency-picker').removeClass('inr');
      $('header .currency-picker').addClass('usd');
    }   
    $('header .currency-picker').val(val);
    money(val,default_selected);
  });  

  // sticky header
  
  if(temp != 'product' || temp != 'blog' || temp != 'blog.all' || temp != 'article' || temp != 'page.members') {
    $(window).scroll(function() {
      var sticky = $('.nav-menu'),
          scroll = $(window).scrollTop();
      if (scroll >= 75) {
        sticky.addClass('fixed');
        $('header').addClass('is-fixed');
      } else {
        sticky.removeClass('fixed');
        $('header').removeClass('is-fixed');
      }

      if(temp.startsWith("collection") == true){
        stickyBtnFilter();
      }
    });
  }
  
  if(temp == 'product' || temp == 'blog' || temp == 'blog.all' || temp == 'article' || temp == 'page.members') {
    $(window).scroll(function() {
      var sticky = $('.nav-menu'), scroll = $(window).scrollTop();
      if (scroll >= 0) sticky.addClass('fixed');
      else sticky.addClass('fixed');
    });
  }
  
  // Quantity update
  $(document).on('click','.qty-minus, .qty-plus', function(){
    var curr_val = parseInt($(this).parents('.qty-i-box').find('input[type="number"]').val());
    if($(this).attr('data') == 'minus') {
      if(curr_val != 1) {
        $(this).parents('.qty-i-box').find('input[type="number"]').val(curr_val-1);
      }
    }
    else {
      $(this).parents('.qty-i-box').find('input[type="number"]').val(curr_val+1);
    }
  });

  // Header search icon
  $('.search-icon').on("click",function(){
    $('.form-open').toggleClass('open');
  });

  // Menu
  $('.level1-menu ul').each(function() {
    if($(this).find('li').length > 6) {
      $(this).parent('.level1-menu').addClass('menu-sp-2');
    } else {
      $(this).parent('.level1-menu').addClass('menu-sp-1');
    }
  });
  
  $('.level1').each(function() {
    if ($(this).find('.level1-menu').length < 2) {
      $(this).addClass('menu-sp-full');
    }
  });

//   $('.res-search-i').on('click', function(){
//     $('.right-icon').addClass('show');
//     $('.c-mask').addClass('open');
//     $('body').removeClass('menu-opened');
//     $('.nav-menu').removeClass('margin-top');
//     $('.nav-menu').removeClass('sticky-menu');
//   });

  $('.close-srch, .c-mask').on('click', function(){
    $('.right-icon').removeClass('show');
    $('.c-mask').removeClass('open');
    $('body').removeClass('menu-opened');
    setTimeout(function(){
      $('.nav-menu').removeClass('sticky-menu');
    },500);
    $('.nav-menu').removeClass('margin-top');
    $('.nav-menu-xs ul li').removeClass('active');
  });

  $('.menu-icon, .res-search-i').on('click', function(){
    $('body').addClass('navmenu-opened');
    $('.nav-menu').addClass('opened');
    $('.c-mask').addClass('open');
    $('body').removeClass('menu-opened');
    $('.nav-menu').removeClass('sticky-menu');
    $('.nav-menu').removeClass('margin-top');
    $('body').addClass('menu-drawer-open');
    $('.nav-menu-xs ul li').removeClass('active');
    $('.nav-menu-xs ul li a').removeClass('active');
//     $('.nav-menu').removeClass('sticky-opened');
  });

  if($(window).width() <= 767) {
    
    $('.nav-menu .menu-li > a').on('click', function(){
      
//       $(this).toggleClass('active').parent('.menu-li').siblings('.menu-li').find('a').removeClass('active');
//       $(this).parent('.menu-li').find('.level1').slideToggle().parent('.menu-li').siblings('.menu-li').find('.level1').slideUp();
      
      var $this = $(this);
      var next = $this.parent('.menu-li').find('.level1');
      
      
      if($this.hasClass('active')) {
        $this.removeClass('active');
        next.slideUp(400);
      } else {
        if($('.menu-li > a').hasClass('active') && $(this).next('.level1').length > 0) {
          var height = $('.menu-li > a.active').next('.level1').innerHeight();
          var offset = ($('.nav-menu').scrollTop() - height) + ($this.offset().top - $(window).scrollTop());
          console.log('offset', $(this).offset().top, offset);
          $this.parents('.nav-menu').find('.menu-li > a').not($this).removeClass('active');
          next.parents('.nav-menu').find('.level1').not(next).slideUp(400);
          $('.nav-menu').animate({ scrollTop: offset }, 400);
          $this.addClass('active');
          next.slideDown(400);
          
        } else {
          $this.addClass('active').parents('.nav-menu').find('.menu-li > a').not($this).removeClass('active');
          next.slideDown(400).parents('.nav-menu').find('.level1').not(next).slideUp(400);
        }
      }
      
    });
    
    $('.nav-menu .level2 a span').each(function(){
      var firstLetter = $(this).text().substr(0,1);
      $(this).html($(this).text().substr(1));
    });
  }

  // Megamenu product image change on hover
  $('.mega-menu .collection_link').on('mouseenter', function(){
    if($('.prdct-'+$(this).attr('data')).length) {
      $('.prdct-'+$(this).attr('data')).eq(0).show().siblings('.menu-prdct').hide();
    }
  });

  $('.mega-menu .sub-img-wrap').on('mouseenter', function(){
    if($('.prdct-'+$(this).parents('li').attr('data')).length) {
      $('.prdct-'+$(this).parents('li').attr('data')).eq(0).show().siblings('.menu-prdct').hide();
    }
  });

  if(temp == 'index') {
    // home page slideshow
//     $('.main-banner').slick({
//       infinite: true,
//       slidesToShow: 1,
//       slidesToScroll: 1
//     });

    // Home page editor's picks section
    $('.editor-slider').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [        
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            adaptiveHeight: true,
            arrows:false,
            dots:true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,
            arrows:false,
            dots:true
          }
        }       
      ]
    });

    // Home page client stories section
    if($(window).width() < 768) {
      $('.client-story .view_more').click(function(){
        $('.client-story .content p').toggleClass('expanded');
        if ($(".client-story .content p").hasClass("expanded")) {
          $(this).text('READ LESS');
        }
        else{
          $(this).text('READ MORE');
        }
      });

      $('.client-story .content .text').each(function(){
        if($(this).innerHeight() < 100 ){
          $(this).parents('.client-story').find('.view_more').addClass('hide_more_btn');
        }
        else{
          $(this).parents('.client-story').find('.view_more').removeClass('hide_more_btn');
        }
      });    

    }

    //   $('.client-story .content .text').each(function(i, e){
    //     var str = $(this).text();
    //     if(str.indexOf('...') != -1 ){
    //       if($(this).hasClass('hidden-xs')){
    //         $(this).parents('.content').find('.read_more.hidden-xs').text('READ MORE').addClass('bottom-line');
    //       }else if($(this).hasClass('visible-xs')){
    //         $(this).parents('.content').find('.read_more.visible-xs').text('READ MORE').addClass('bottom-line');
    //       }

    //     }
    //     else{
    //       if($(this).hasClass('hidden-xs')){
    //         $(this).parents('.content').find('.read_more.hidden-xs').text('').removeClass('bottom-line');
    //       }else if($(this).hasClass('visible-xs')){
    //         $(this).parents('.content').find('.read_more.visible-xs').text('').removeClass('bottom-line');
    //       }
    //     }
    //   });

    if ($(window).width() < 768) {
      $('.h-blog-slider').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [        
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              adaptiveHeight: true,
              arrows:false,
              dots:true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              adaptiveHeight: true,
              arrows:false,
              dots:true
            }
          }
        ]
      });
    }
  }
  // Footer
  
  /* Artisera promise */
  $('.f-menu li:nth-child(2)').click(function(){
    var locate_href = $(this).children('a').attr('href');
    locate_href = locate_href.split('/').pop();
    locate_href = locate_href.split('#').pop();
    $('#'+ locate_href);
  });
  
  if($(window).width() < 768){
    $('.about-footer .view_more').click(function(){
      $('.about-footer p').toggleClass('expanded');
      if ($(".about-footer p").hasClass("expanded")) {
        $(this).text('READ LESS');
      }
      else{
        $(this).text('READ MORE');
      }
    });

    // All landing pages and blog pages
    var page_temp = temp.startsWith("page");
    var blog_temp = temp.startsWith("blog");
    if(page_temp == true || blog_temp == true ){
      $('.c-view-more').click(function(){
        $('.heading-p').toggleClass('expanded');
        if ($(".heading-p").hasClass("expanded")) {
          $(this).text('READ LESS');
        }
        else{
          $(this).text('READ MORE');
        }
      });
    }
  }

  // Newsletter form

  // mailchimp form
  $('.newsletter-submit').click(function(){
    var $form = $(this).parents('form');
    var email = $form.find('.txtmail').val();
    if(email == ''){
      $form.find('.error-news').text('Email Required');
      $form.find('.txtmail').focus();
      return false;
    }
    else if(!email.match(email_pattern)) {
      $form.find('.error-news').text('Valid Email Address Required');
      $form.find('.txtmail').focus();
      return false;
    }
    $form.find('.error-news').text("Please wait...");
    $form.find('.w_loading').show();
    var form_action = "https://thewhitepeacock.in/mailchimp_auto/subscribe.php";
    $.ajax({
      url: form_action,
      type: 'POST',
      dataType : 'html',
      data: {
        email: email
      },
      error : function() { 
        $form.find('.error-news').text('');
        $form.find('.error-news').addClass('required_field');
        $(".required_field").text("Could not connect to server. Please try again later.");
        $form.find('.w_loading').hide();
      },
      success : function(data) {
        $form.find('.w_loading').hide();
        $(".required_field").text('');
        $form.find('.error-news').removeClass('required_field');
        $form.find('.error-news').addClass('success_msg');
        $(".success_msg").text("Thank you for Subscribing to Artisera.");

        setTimeout(function(){ 
          $(".success_msg").text("");
          $form.find('.error-news').removeClass('success_msg');
          $form.find('.txtmail').val('');
          $form.closest('.ftr-newsletter').find('#newsletter-thankyou').modal('show');
//           setTimeout(function(){ 
//             $('#newsletter-thankyou').modal('hide');
//           }, 7000);
        }, 100);
      }
    });
  });

  // contact form

  $('.newsletter-contact-submit').click(function(){
    var $form = $(this).parents('form');
    var email = $form.find('.txtmail').val();
    if(email == ''){
      $form.find('.error-news').text('Email Required');
      $form.find('.txtmail').focus();
      return false;
    }
    else if(!email.match(email_pattern)) {
      $form.find('.error-news').text('Valid Email Address Required');
      $form.find('.txtmail').focus();
      return false;
    }
    else{
      $form.find('.error-news').text('');
    }
  });

  // Discover mobile menu for landing pages

  stickyOnTop();
  $(window).scroll(function() {
    stickyOnTop();
  });
  $(window).resize(function() {
    stickyOnTop();
  });
  $('.discover-o-world').on('click', function(){
    stickyOnTop();
  });

  /* comment by pk */
//   $('.discover-o-world .tab:not(.expand-tab) li').on('click', function(){
//     if($(this).hasClass('active')){
//       $(this).removeClass('active');
//       $(this).parents('.main-tab').find($('#'+$(this).find('a').attr('data-link'))).slideUp();
//     }
//     else{
//       $('.discover-o-world .tab li').removeClass('active');
//       $('.discover-o-world .tab_content').hide();
//       $(this).addClass('active');
//       $(this).parents('.main-tab').find($('#'+$(this).find('a').attr('data-link'))).slideDown();
//     }
//   });

//   $(".discover-o-world .nav-arrow span").on("click",function(){
//     if($(this).hasClass("active")){
//       $(this).removeClass("active");
//       $(".discover-o-world .expand-tab").slideUp();
//       $(".discover-o-world .tab").removeClass('open');
//     }else{
//       $(this).addClass("active");
//       $(".discover-o-world .expand-tab").slideDown();
//       $(".discover-o-world .tab").addClass('open');
//     }
//   });
  
    $('.discover-o-world .tab:not(.expand-tab) li').on('click', function(){
      if($(this).hasClass('active')){
        $('.discover-o-world .nav-arrow span').removeClass('active');
        $(".expand-tab").slideUp().delay(400);
        $(this).removeClass('active');
        $(this).parents('.main-tab').find($('#'+$(this).find('a').attr('data-link'))).slideUp();
      }
      else{
        $('.discover-o-world .nav-arrow span').addClass('active');
        $('.discover-o-world .tab li').removeClass('active');
        $('.discover-o-world .tab_content').hide();
        $(".expand-tab").slideDown();
        $(this).addClass('active');
        $(this).parents('.main-tab').find($('#'+$(this).find('a').attr('data-link'))).slideDown().delay(400);
      }
    });

    $(".discover-o-world .nav-arrow span").on("click",function(){
      if($(this).hasClass("active")){
        $(this).removeClass('active');
        $('body').removeClass('o-hidden');
        $(".discover-o-world .tab").removeClass('open');
        $('.discover-o-world .tab li').removeClass('active');
        $(".discover-o-world .expand-tab").slideUp().delay(400);
        $('.discover-o-world .tab_content').slideUp();
      } else {
//         $('.discover-o-world .tab:not(.expand-tab) li').eq(0).trigger('click');
        $(this).addClass("active");
        $(".discover-o-world .expand-tab").slideDown();
        $(".discover-o-world .tab").addClass('open');
      }
    });

  // Artists page

  if ($(window).width() <= 767){
    $('.artist-page .more-artist').hide();
    $('.artist-page .btn-show-more').show();
    $('.artist-page .btn-show-less').hide();
    $('.artist-page .btn-show-more').on('click', function(){
      var art_mdata = $(this).attr('data');
      $('.artist-page .more-artist-'+art_mdata).fadeIn();
      $('.artist-page .show-more-'+art_mdata).hide();
      $('.artist-page .show-less-'+art_mdata).show();
    });
    $('.artist-page .btn-show-less').on('click', function(){
      var art_ldata = $(this).attr('data');
      $('.artist-page .more-artist-'+art_ldata).hide();
      $('.artist-page .show-more-'+art_ldata).show();
      $('.artist-page .show-less-'+art_ldata).hide();
      $(window).scrollTop(($(this).parent().prev('.page-title').find('.sub_heading').offset().top) -80);      
    });
  }

  $(".c1").click(function() {
    if($(".nav-menu").hasClass('fixed')){
      var c_offset = $(".sec1").offset().top - 105;                     
    }else{
      var c_offset = $(".sec1").offset().top - 153;
    }
    if($(window).width() <= 1199) {
      if($(".nav-menu").hasClass('fixed')){
        var c_offset = $(".sec1").offset().top - 95;                     
      }else{
        var c_offset = $(".sec1").offset().top - 135;
      }
    }
    if($(window).width() <= 767) {
      var c_offset = $(".sec1").offset().top - 80;
    }
    $('html,body').animate({scrollTop: c_offset}, 'slow');    
  });

  $(".c2").click(function() {
    if($(".nav-menu").hasClass('fixed')){
      var c_offset = $(".sec2").offset().top - 105;                     
    }else{
      var c_offset = $(".sec2").offset().top - 153;
    }
    if($(window).width() <= 1199) {
      if($(".nav-menu").hasClass('fixed')){
        var c_offset = $(".sec2").offset().top - 95;                     
      }else{
        var c_offset = $(".sec2").offset().top - 135;
      }
    }
    if($(window).width() <= 767) {
      var c_offset = $(".sec2").offset().top - 80;
    }
    $('html,body').animate({scrollTop: c_offset}, 'slow');    
  });

  $(".c3").click(function() {
    if($(".nav-menu").hasClass('fixed')){
      var c_offset = $(".sec3").offset().top - 105;                     
    }else{
      var c_offset = $(".sec3").offset().top - 153;
    }
    if($(window).width() <= 1199) {
      if($(".nav-menu").hasClass('fixed')){
        var c_offset = $(".sec3").offset().top - 95;                     
      }else{
        var c_offset = $(".sec3").offset().top - 135;
      }
    }
    if($(window).width() <= 767) {
      var c_offset = $(".sec3").offset().top - 80;
    }
    $('html,body').animate({scrollTop: c_offset}, 'slow');    
  });

  $(".c4").click(function() {
    if($(".nav-menu").hasClass('fixed')){
      var c_offset = $(".sec4").offset().top - 105;                     
    }else{
      var c_offset = $(".sec4").offset().top - 153;
    }
    if($(window).width() <= 1199) {
      if($(".nav-menu").hasClass('fixed')){
        var c_offset = $(".sec4").offset().top - 95;                     
      }else{
        var c_offset = $(".sec4").offset().top - 135;
      }
    }
    if($(window).width() <= 767) {
      var c_offset = $(".sec4").offset().top - 80;
    }
    $('html,body').animate({scrollTop: c_offset}, 'slow');    
  });

  $(".c5").click(function() {
    if($(".nav-menu").hasClass('fixed')){
      var c_offset = $(".sec5").offset().top - 105;                     
    }else{
      var c_offset = $(".sec5").offset().top - 153;
    }
    if($(window).width() <= 1199) {
      if($(".nav-menu").hasClass('fixed')){
        var c_offset = $(".sec5").offset().top - 95;                     
      }else{
        var c_offset = $(".sec5").offset().top - 135;
      }
    }
    if($(window).width() <= 767) {
      var c_offset = $(".sec5").offset().top - 80;
    }
    $('html,body').animate({scrollTop: c_offset}, 'slow');    
  });

  /* career artist tab only */
  $('.artist-tab-3 .artist_section .overlay').click(function() {
    let targetSection;

    if ($(this).hasClass('c6')) {
        targetSection = '.sec6';
    } else if ($(this).hasClass('c7')) {
        targetSection = '.sec7';
    } else if ($(this).hasClass('c8')) {
        targetSection = '.sec8';
    } else if ($(this).hasClass('c9')) {
        targetSection = '.sec9';
    } else {
        targetSection = '.sec6'; // Default for the last overlay
    }

    // Calculate the offset based on the nav-menu class
    let c_offset;
    if ($(".nav-menu").hasClass('fixed')) {
        c_offset = $(targetSection).offset().top - 105;
    } else {
        c_offset = $(targetSection).offset().top - 153;
    }

    // Adjust for smaller screen sizes
    if ($(window).width() <= 1199) {
      if ($(".nav-menu").hasClass('fixed')) {
          c_offset = $(targetSection).offset().top - 95;
      } else {
          c_offset = $(targetSection).offset().top - 135;
      }
    }

    if ($(window).width() <= 767) {
      c_offset = $(targetSection).offset().top - 80;
    }

    $('html, body').animate({ scrollTop: c_offset }, 'slow');
  });

  
  //Artisera promise

 /* $(window).load(function(){
    var locate = window.location.href;
    if(locate.indexOf('#') > -1 ){
      if($(window).width() <= 767) {
        if($(".story-i-txt.sec-i-right").length){
          var c_offset = $(".story-i-txt.sec-i-right").offset().top - 65
          }
      }
      else if($(window).width() >= 1200 && $(window).width() <= 1400 ){
        if($(".story-i-txt.sec-i-right").length){
          var c_offset = ($(".story-i-txt.sec-i-right").offset().top - 90) + ($('.nav-menu.fixed').innerHeight())
          }
      }
      else{
        if($(".story-i-txt.sec-i-right").length){
          var c_offset = ($(".story-i-txt.sec-i-right").offset().top - 100) + ($('.nav-menu.fixed').innerHeight())
          }
      }
      setTimeout(function(){
        $('html, body').scrollTop(c_offset);
      },50);
    }

    /*$('.f-menu li:nth-child(2)').click(function(){
      window.location.href = '#';
      locate = window.location.href;
      if(locate.indexOf('#') > -1 ){
        $('html, body').scrollTop($(".story-i-txt.sec-i-right").offset().top - 75 );
        //       $('html, body').animate({
        //         scrollTop: $(".story-i-txt.sec-i-right").offset().top - 75
        //       }, 3000);
      }
    });
  });*/
  
  //collection pages
  
//   if(temp == 'collection'){
//     $(window).load(function(){
//       console.log('call',Shopify.queryParams.sort_by);
//       if ($(".selected_data").is(':visible')) {
//         console.log('call_filter')
//         $(".advance-filter").hide();
//         $(".adv-sort").hide();
//         $(".filter-div").show();
//       }
//       else if(Shopify.queryParams.sort_by != undefined && Shopify.queryParams.sort_by != ''){
//         console.log('call_sorting');
//         $(".advance-filter").hide();
//         $(".adv-sort").hide();
//         $(".filter-div").show();
      
//       }
//       else {
//         console.log('call_null');
//         $(".advance-filter").show();
//         $(".adv-sort").show();
//         $(".filter-div").hide();
//       }
//     });
//   }
  
  var col_temp = temp.startsWith("collection");
  if(col_temp == true){

    /*
    $(window).scroll(function() {
      var sticky = $('.nav-menu'),
          scroll = $(window).scrollTop();
      if (scroll >= 75) {
        sticky.addClass('fixed');            
      }
      else {
        sticky.removeClass('fixed');
      }
      stickyBtnFilter();
    });*/
    
    stickyBtnFilter();
    var offset_Top;
    $('.show-filter a').click(function(){
      offset_Top = 100 ;
      if($(".advance-filter").is(':visible')){
        offset_Top = 125 ;
      }
      $('html, body').animate({scrollTop: $(".filter-div:visible, .advance-filter:visible").offset().top - offset_Top}, 1000);
    });
    
    setTimeout(function(){
      var locate = window.location.href;
      if(locate.indexOf('#') > -1 ){
        $('.spc_filtr_li a').addClass('spcial_filtr_artist');
        $('.spc_filtr_tableware_li a').addClass('spcial_filtr_tableware_artist');
        if($('.spcial_filtr_artist').length){
          $('.spcial_filtr_artist').addClass('active').parent().addClass('active');
          $('#f-artist').toggle();
        }
        if($('.spcial_filtr_tableware_artist').length){
          $('.spcial_filtr_tableware_artist').addClass('active').parent().addClass('active');
          $('#f-category').toggle();
        }
      }
    },300);

    if($(window).width() > 767){
      // applied filter indicate in desktop
      
      setTimeout(function(){
        $(".filter-detail .filter-group:visible").each(function(i,v){
          if($(this).find(".f-open .selected a").length > 0){
            $(this).find(".f-open .selected a").each(function(){
              //  alert('1');	
              $(".selected_data > div").append('<span index="'+i+'">'+$(this).text()+' <i class="cross_icon"></i></span>');
              $(".selected_data").show();
            })
          }//else{
          //$(this).find('.filter_click').text($(this).find('h4').text());
          //       }
        });
      },300);
      
//       $(window).load(function(){
//         if ($(".selected_data").is(':visible')) {
//           //       console.log('call_filter')
//           $(".advance-filter").hide();
//           $(".adv-sort").hide();
//           $(".filter-div").show();
//           $('body').addClass('hide_spec_filter');
//         }
//         //     else if(Shopify.queryParams.sort_by != undefined && Shopify.queryParams.sort_by != ''){
//         // //       console.log('call_sorting');
//         //       $(".advance-filter").hide();
//         //       $(".adv-sort").hide();
//         //       $(".filter-div").show();

//         //     }
//         else {
//           //       console.log('call_null');
//           $(".advance-filter").show();
//           $(".adv-sort").show();
//           $(".filter-div").hide();
//           $('body').removeClass('hide_spec_filter');
//         }
//       });
      
    }

    filter_url = '';

    $('.c-view-more').click(function(){
      $('.c-descrption').toggleClass('expanded');
      if ($(".c-descrption").hasClass("expanded")) {
        $(this).text('READ LESS');
      }
      else{
        $(this).text('READ MORE');
        if($(window).width() > 767) {
          var scrollTop = $('.c-view-animate').offset().top - 50;
        } else {
          var scrollTop = $('.c-view-animate').offset().top - 30;
        }
        $(window).scrollTop(scrollTop);
      }
    });

    if($('.c-descrption').innerHeight() < $('.c-desc-inner').innerHeight()){
      $(this).parents('.collection-text').find('.c-view-more').show();      
    }
    else{      
      $('.c-view-more').hide();
      if(temp == 'collection' || temp == 'collection.list'){
        $('.collection-text').addClass('default-height');
      }
    }

    if($(window).width() > 767){
      $(".filter_click").click(function(e) {
        e.stopPropagation();
        $(this).toggleClass('active');
        $(".filter_click").not($(this).parent().find(".filter_click")).removeClass('active');
        $(".f-open").not($(this).parent().find(".f-open")).hide(); 
        $(this).parent().find(".f-open").toggle();
      });
      
      // Filter outside click closed dropdown
      $("body").click(function(){
        $(".filter-group .f-open").hide();
        $(".filter-group .filter_click.active").removeClass('active');
      });
      
      // scroll to filter after filter and sorting applied on page load

        setTimeout(function(){
          if($('.selected_data').is(':visible') || $('.sort-by').hasClass('has_applied_sort') || $('.spcial_filtr_artist').is(':visible') || $('.spcial_filtr_tableware_artist').is(':visible')){
//             $('html, body').animate({ scrollTop: $('.filter-div:visible,.advance-filter:visible').offset().top - 120 }, 2000);
//             $('html, body').scrollTop($('.filter-div:visible,.advance-filter:visible').offset().top - 120 );
            if($('.selected_data').is(':visible')) {
              $('html, body').scrollTop($('.filter-div').offset().top - 120 );
            } 
            else if($('.spcial_filtr_artist').is(':visible') || $('.spcial_filtr_tableware_artist').is(':visible')) {
              $('html, body').scrollTop($('.advance-filter').offset().top - 150 );
            }
            else if($('.sort-by.special_sorting').hasClass('has_applied_sort')) {
              $('html, body').scrollTop($('.advance-filter:visible').offset().top - 150 )
            }
            else{
              $('html, body').scrollTop($('.filter-div').offset().top - 120 );
            }
            
          }
        }, 500);


      $(document).on("click",".cross_icon", function(){
        var i = $(this).parent().attr('index');
        var text = $(this).parent().text();
        // 	$(".filter-detail .filter-group:visible").eq(i).find('.f-open').find('a')[0].click()
        $(".filter-detail .filter-group:visible").eq(i).find('.f-open').find('a:contains("'+$.trim(text)+'")')[0].click();

      });
      
      if($('.f-by-price .spc-filter').length < 5) {
        $('.adv-f-container').addClass('price-not-has-5');
      }
      
    }
    
    /* remove Title attribute from all filter */
    $(".advance-filter a").removeAttr("title");
    $(".filter-div a").removeAttr("title");
      
    /* Mobile filter and sorting all script */
    if($(window).width() < 768){

      $(".filter_click").on("click",function() {
        if($(this).hasClass("active")){
          $(this).removeClass("active");
          $(this).parents(".new_group").removeClass('opened_div');
          $(this).parents(".new_group").find(".f-open").slideUp();        
        }else{
          $(this).parents(".new_group").find(".f-open").slideDown();
          $(".new_group").removeClass('opened_div')
          $(this).parents(".new_group").addClass('opened_div')
          $(this).addClass("active");
        }
        $(this).parents(".new_group").siblings().find(".f-open").slideUp();
        $(this).parents(".new_group").siblings().find(".filter_click").removeClass("active");
      });
      /* Apply filter on button click */
      if($(".has_selected").length)
      {
        $(".filter-menu>div>h4").addClass('gold');
        $(".filter-menu>div>span").addClass('gold');
      }
      $(".has_selected").show();
      $(".has_selected").parent().addClass('opened_div');
      $(".has_selected").parent().find('h4').addClass('active');


      /* Mobile filter text change select to applied */
      if($('span.gold').length){
        $('span.gold').text('Applied');
      }
      else{
        $('.filter-group.refine-header.visible-xs span').text('Select');
      }
      
      // scroll to filter after filter applied on page load mobile
//       setTimeout(function(){ 
//         if($('span.gold').length || $(".m_sort").find('a[href="?'+url_arr[1]+'"]').hasClass('selected')){
//           var offset_top = '';
//           if($('span.gold').length){
//             offset_top = 120
//           }
//           else if($(".m_sort").find('a[href="?'+url_arr[1]+'"]').hasClass('selected')){
//             offset_top = 50
//           }
//           else if($('span.gold').length && $(".m_sort").find('a[href="?'+url_arr[1]+'"]').hasClass('selected')){
//             offset_top = 70
//           }
//           console.log(offset_top)
//           $('html, body').animate({ scrollTop: $('.gallery').offset().top - offset_top }, 2000);
//         }
//       }, 300);
      
        setTimeout(function(){ 
          if($('span.gold').length || $(".m_sort").find('a[href="?'+url_arr[1]+'"]').hasClass('selected') || $('.selected_data').is(':visible') || $('.spcial_filtr_artist').is(':visible')){
            var offset_top = $('header').innerHeight() - 1;
            $('html, body').scrollTop($('.filter-div:visible,.advance-filter:visible').offset().top - offset_top );
          }
        }, 300);
      
      // applied filter indicate in mobile
      
      setTimeout(function(){
        $(".filter-detail .filter-group").each(function(i,v){
          
          if($(this).find(".f-open.has_selected .selected a").length ){
            $(this).find(".f-open.has_selected .selected a").each(function(){
              //  alert('1');	
              $(".selected_data > div").append('<span index="'+i+'">'+$(this).text()+' <i class="cross_icon"></i></span>');
              $(".selected_data").show();
            })
           }//else{
//              $(this).find('.filter_click').text($(this).find('h4').text());
//           }
        });
      },300);
      
      // applied filter close icon remove filter in mobile
      
      $(document).on("click",".cross_icon", function(){
        var i = $(this).parent().attr('index');
        var text = $(this).parent().text();
        // 	$(".filter-detail .filter-group:visible").eq(i).find('.f-open').find('a')[0].click()
        $(".filter-detail .filter-group").eq(i).find('.f-open.has_selected').find('a:contains("'+$.trim(text)+'")')[0].click();
        $(".filter-overlay").removeClass("open");
        $("body").removeClass("f-b-open");
      });

      /* Mobile click on apply filter link change */

//       $(document).on("click",".collection-container a",function(e){
//         if(!$(this).parents('li').hasClass('selected')){
//           e.preventDefault();
//         }
//         $(this).toggleClass('active');
//         $(this).parents('.filter_div').find('a').not(this).removeClass('active')
//         filter_url ='';
//         //$(this).parents('.filter_div').find('.collection-container').each(function(){

//         var href = $(this).attr('href');
//         if(href != undefined){
//           var filtr_arr = href.split('/');
//           var filtr = filtr_arr[filtr_arr.length -1 ];
//           //if(filter_url == ''){
//           filter_url = "/collections/"+filtr_arr[2]+"/"+filtr;
// //           }else{
// //             var f_arr = filtr.split('+');
// //             filter_url = "+"+f_arr[f_arr.length-1];
// //           }
//         }
//         //})
//         if(filter_url == ''){
//           $(".filtr_apply").attr('href','javascript:void(0)');
//         }else{
//           $(".filtr_apply").attr('href',filter_url);
//         }
//       })

      /* click on cancle button of filter and shorting */

      $(".filtr_cancel").on("click",function(){
        //             $("ul.price-fil li,ul.artist-fil li,ul.mobile_sort li").removeClass("active");
        //             $("ul.price-fil li:first-child,ul.artist-fil li:first-child,ul.mobile_sort li.m_sort:first-child").addClass("active");

        $(".filter_div").slideUp();
        $(".sorting-area ul").slideUp();
        $(".sorting-area .sort").removeClass("active");
        $(".filter-group.refine-header").removeClass("active");
        $(".filter-overlay").removeClass("open");
        $("body").removeClass("f-b-open");
      });

      /* mobile change default value to selected value sorting and add X icon for remove sorting */

      var url = window.location.href;
      url_arr = url.split('?');
      if(url_arr[1] != undefined){
        var txt = $(".sorting-area .m_sort").find('a[href="?'+url_arr[1]+'"]').text();
        var txt1 = $(".adv-sort .m_sort").find('a[href="?'+url_arr[1]+'"]').text();
        //$(".m_sort").find('a[data-href="?'+url_arr[1]+'"]').addClass('selected').after('<i class="check-icon remove_sort">x</i>');
        $(".m_sort").find('a[href="?'+url_arr[1]+'"]').addClass('selected');
        $(".sorting-area .default_sort").text(txt);
        $(".adv-sort .default_sort").text(txt1);
        if(txt =='' || txt == undefined){
          $(".sorting-area .default_sort,.adv-sort .default_sort").text('featured');
        }
        
        // scroll to filter after sorting applied on page load
//         setTimeout(function(){ 
//           if($(".m_sort").find('a[data-href="?'+url_arr[1]+'"]').hasClass('selected')){
//             $('html, body').animate({ scrollTop: $('.gallery').offset().top - 100 }, 2000);
//           }
//         }, 300);

//         $('.remove_sort').click(function(){
//           window.location.href = url_arr[0];
//         });

      }else{
        $(".m_sort").find('a[href="?'+url_arr[1]+'"]').removeClass('selected').after('');
        $(".sorting-area .default_sort,.adv-sort .default_sort").text('featured');
      }

       /* mobile sorting */
//       $(document).on('click','.m_sort a',function(e){
//         $(".m_sort a").removeClass('active');
//         $(this).addClass('active');
//         $(this).parents('.mobile_sort').find('.filtr_apply').attr('href',$(this).attr('data-href'));
//       });

      /* comment by H for toggle filter and sort in mobile */
      /*
      $(document).mouseup(function (e){
        console.log('call mouse');
        var filter_container = $(".new_filter");

        if (!filter_container.is(e.target)
            && filter_container.find(e.target).length === 0)
        {
          filter_container.slideUp();
//           filter_container.hide();
          $(".filter-overlay").removeClass("open");
          $("body").removeClass("f-b-open");
          $('.filter-group').removeClass('active');
        }


        var sort_container = $(".mobile_sort");
        if (!sort_container.is(e.target)
            && sort_container.has(e.target).length === 0)
        {
          sort_container.slideUp();
//           sort_container.hide();
          $(".filter-overlay").removeClass("open");
          $("body").removeClass("f-b-open");
          $('.sorting-area').find('.active').removeClass('active');
        }

      });*/

      /* mobile sticky filter */

      $(window).scroll(function() {
        if($('.filter-div').is(':visible')){
          var sticky = $('.filter-div').offset().top - $('header').innerHeight(),
              scroll = $(window).scrollTop();
          if (scroll >= sticky) {
            $('.filter-div').addClass('fixed');
            $('.gallery').addClass('filter-fixed');
          }
          else {
            $('.filter-div').removeClass('fixed');
            $('.gallery').removeClass('filter-fixed');
          }
        }
      });

      /* mobile filter click */

      $(".filter-group.refine-header").click(function(){
        //         var s_top = 0
        //         s_top = $(".filter-group.refine-header").offset().top - ($(".header-bottom").height() + 50)
        //         $(window).scrollTop(s_top)  

        $(".sorting-area .sort").removeClass("active");
        $(".sorting-area ul").slideUp();
        if($(this).hasClass("active")){
          $(this).removeClass("active");
          $(".filter-overlay").removeClass("open");
          $("body").removeClass("f-b-open");
          $(".filter_div").slideUp();
        }else{
          $(this).addClass("active");
          $(".filter-overlay").addClass("open");
          $("body").addClass("f-b-open");
          $(".filter_div").slideDown();
        }
      });


      $(".sorting-area .sort").click(function(e){
        e.stopPropagation();
        //         var s_top = 0
        //         s_top = $(".sorting-area .sort").offset().top - ($(".header-bottom").height() + 50)
        //         $(window).scrollTop(s_top)

        $(".filter-group.refine-header").removeClass("active");
        $(".filter_div").slideUp();

        if($(this).hasClass("active")){
          $(this).removeClass("active");
          $(".filter-overlay").removeClass("open");
          $("body").removeClass("f-b-open");
          $(".sorting-area ul").slideUp();
        }else{
          $(this).addClass("active");
          $(".filter-overlay").addClass("open");
          $("body").addClass("f-b-open");
          $(".sorting-area ul").slideDown();
        }

      });
      $(".filter_div,.mobile_sort").click(function(e){
        if (!$(e.target).is('.filtr_cancel')) {
          $(".filter-overlay").addClass("open");
          $("body").addClass("f-b-open");
        }     
      });

      $(window).on('scroll', function(){
        var windowOffBottom = $(window).scrollTop() + $(window).innerHeight();
        if(windowOffBottom >= $('#shopify-section-footer').offset().top) {
          $('.collection-pg').addClass('fixed-o');
        } else {
          $('.collection-pg').removeClass('fixed-o');
        }
      });
      
      $('.filter-overlay').on('click', function(){
        $('.filtr_cancel').trigger('click');
      });
    }
    
    /* end mobile filter and sorting all script */
    
  }


    $('.phone-in').on('click', function(){
      $(this).next('.phone-number').toggle();
    });
    
    //Indian traditional art collection
    if(temp == 'collection.indian-traditional-art' ){
      $('.editor-slider').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [        
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              adaptiveHeight: true,
              arrows:false,
              dots:true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              adaptiveHeight: true,
              arrows:false,
              dots:true
            }
          }       
        ]
      }); 
    }
  
  // all modal close from here
  $('.close-modal').on("click",function(){
    $(this).parents('.modal').removeClass('in');
    $('.modal-backdrop').removeClass('in');
    $('body').removeClass('modal-open');
    $('.modal-backdrop').hide();
    $(this).parents('.modal').modal('hide');
//     $(this).parents('.modal').find('.w_loading').hide();
  });
  
  
  if(temp == 'search'){
    function attachClickEvent(){
      loadMore();
    }

    function loadMore() {
      var ScrollNode = $('.load-more').last(); 
      var url = $('.load-more a').last().attr("href");
      if(ScrollNode.length > 0 && ScrollNode.css('display') != 'none'){
        $.ajax({
          url: url,
          dataType: 'html',
          success: function(html) {
            ScrollNode.next().remove();
            ScrollNode.remove();
            var $productGrid = $(html).find('.collection-matrix').html();
            $('.collection-matrix').append($productGrid);
          }
        });
      }
    }
    
    $(window).scroll(function(){
      attachClickEvent();
    });
    
  }
  
  
  if(temp == 'cart'){
    $(document).on('change', '.qty-cart', function(){
      var curr_qty = $(this).val();
      var var_id = $(this).attr('data-id');
      var err_msg = '';

      if($(this).attr('max') != '' && curr_qty > $(this).attr('max')) {
        curr_qty = $(this).attr('max');
        err_msg = 'All '+curr_qty+' '+$(this).parents('.cart-qty').attr('data-title')+' in your cart';
      }
      
      cart_update(var_id,curr_qty,err_msg);
      $('.img-loader').show();
    });
    
    $(".f_click").on("click",function(){
      $(".shipping-o-india").slideToggle();
      $('html, body').animate({ scrollTop: $('.shipping-o-india').offset().top - 50 }, 1000);
    });
    
    $(".btn-close-shippingfrm").on("click", function(){
      $(".shipping-o-india").slideUp();
      $('html, body').animate({ scrollTop: $(".grand_total").offset().top - 60 }, 700);
    });
  }
  
  var blog_temp = temp.startsWith("blog");
  if(blog_temp == true){
    $(".press_main_img").click(function(){
      var href = $(this).attr("data-href");
      $.fancybox({
        fitToView	: false,
        height    : '100%',
        width     : '100%',
        autoSize	: false,
        href      :"#press_img",
        beforeShow:function(){
          $("#press_img img").attr("src",href);
        }

      });
    });
  }

  if(temp == 'blog.testimonial'){
    if($(window).width() < 768){
      $('.testimonials-pg .view_more').click(function(){
        $('.testimonials-pg .text').toggleClass('expanded');
        if ($(".testimonials-pg .text").hasClass("expanded")) {
          $(this).text('READ LESS');
        }
        else{
          $(this).text('READ MORE');
        }
      });    

      $('.show_description .text').each(function(){
        if($(this).innerHeight() < $(this).find('.desc-inner').innerHeight()){
          $(this).parents('.box-shadow-div').find('.view_more').show();
        }
        else{
          $(this).parents('.box-shadow-div').find('.view_more').hide();
        }
      });
    }
  }
  
//   members page slider 
  $('.i-coll-img-slider').slick({
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false
        }
      }
    ]
  });
  
});/* document.ready closed */

function money(currency,default_curr){
  $(".money").each(function(){
    var money_text = $(this).attr("money");
    if(money_text != undefined){
      var html = $.parseHTML(money_text);
      var text = $(html).text(); 
      var money = text.split(" ");
      var symbol = "";

      money = money[1]; 
      money = money.replace(/,/g,'');

      if(currency == "INR"){
        symbol = "Rs. ";
      }
      else{
        symbol = "$ ";
      }

      var con_money = Currency.convert(money, default_curr, currency).toFixed(2);
      var round_money = Math.round(con_money).toString();
      round_money = CurrencyFormat(round_money);
      var final_money = symbol + round_money;
      if($(this).hasClass("compare_money")){
        $(this).text("Now at "+final_money);
      }else{
        $(this).text(final_money);
      }
      $(this).text(final_money);
    }
  });
}

function CurrencyFormat(number){
  var integer = number;
  integer = new Intl.NumberFormat('en-IN').format(integer);
  return integer;
  
  /*var thousandseparater = ",";
  var strnumber = new String(number);
  var integer = strnumber;
  if( integer ) { integer = String(Math.abs(integer)); }
  var temparray = new Array();
  while( integer.length > 3 ){
    temparray.unshift(integer.substr(-3));
    integer = integer.substr(0,integer.length-3);
  }
  temparray.unshift(integer);
  integer = temparray.join(thousandseparater);
  return integer;*/
}

function closeNav() {
  $('.nav-menu').removeClass('opened');
  $('.c-mask').removeClass('open');
  $('body').removeClass('menu-drawer-open');
  $('body').removeClass('menu-opened');
  $('.nav-menu').removeClass('margin-top');
  $('.nav-menu-xs ul li').removeClass('active');
  setTimeout(function(){
    $('.nav-menu').removeClass('sticky-menu');
  }, 500);
}

// Discover mobile menu

function stickyOnTop() {
  var windowScroll = $(window).scrollTop();
  var stickyHeight = $('.discover-o-world .ds-title').outerHeight(true) + $('.discover-o-world .main-tab-i').innerHeight();
  var windowOffset = windowScroll + $('header').innerHeight() + stickyHeight + 43;
  var eleOffset = $('#shopify-section-footer').offset().top;
  var scrollHeight = $(window).innerHeight() - $('header').innerHeight() - $('.discover-o-world .ds-title').outerHeight(true) - $('.discover-o-world .nav-arrow span').innerHeight();

  if(windowOffset >= eleOffset){
    $('body').addClass('dis-o-fixed');
    $('.filtr_cancel').click();
    $('.art-filter-mask').click();
    $('.discover-o-world').addClass('fixed');
  } else {
    $('body').removeClass('dis-o-fixed');
    $('.discover-o-world').removeClass('fixed');
  }

  $('.discover-o-wrap').css('min-height', stickyHeight);
  $('.discover-o-world .main-tab').css('max-height', scrollHeight);

  if($(".discover-o-world").hasClass("fixed")){
    $('.discover-o-world .tab:not(.expand-tab) li').on('click', function(){
      if($(this).hasClass('active')){
        $('body').addClass('o-hidden');
      }
      else{          
        $('body').removeClass('o-hidden');
      }
    });
  }
}

function stickyBtnFilter() {
  if($('.gallery').length){
  var glryOffset = $('.gallery').offset().top - 100,
      scroll = $(window).scrollTop();
  if (scroll >= glryOffset) {        
    $('.show-filter').removeClass('hidden');
  }
  else {        
    $('.show-filter').addClass('hidden');
  }
  }
}
var errTimeoutId;
function cart_update(id, qty , err) {
  $.ajax({
    url: '/cart/change.js',
    type: 'POST',
    dataType: 'json',
    data: {
      id: id,
      quantity: qty
    },
    success: function(data) {
      $.ajax({
        url: '/cart',
        type: 'get',
        dataType: 'html',
        success: function(cartHTML) {
          //           console.log(cartHTML);

          //           var form_html = $(cartHTML).find('.cart-form').html();
          //           $('.cart-form').html(form_html);

//           $('.img-loader').hide();

          if(err != '') {
            $('.cart-error').text(err).show();

            clearTimeout(errTimeoutId);

            setTimeout(function(){
              $('.cart-error').text('').hide();
            }, 3000);
          }
          
          setTimeout(function(){
            window.location = '/cart';
          },100);

        }
      });
    }
  });
}

function save_contact_details(contact_details_arr) {
  var contact_obj = null;
  if($.cookie('artisera_contact_details') != null) {
    contact_obj = JSON.parse($.cookie('artisera_contact_details'));
  }
  else {

    if(!$.isEmptyObject(contact_details_arr)){
      var contact_details = JSON.stringify(contact_details_arr);

      $.cookie('artisera_contact_details', contact_details, { expires: 7, path: '/' });
      contact_obj = JSON.parse($.cookie('artisera_contact_details'));
    }
  }
  
  if(contact_obj != null){
    $('.similar_nm, .inquery_nm, .txtfullname').val(contact_obj.name);
    $('.similar_email, .inquery_email').val(contact_obj.email);
    $('.similar_phn, .inquery_phn').val(contact_obj.phone_no);
    $('.inquery_city').val(contact_obj.city);
    $('.inquery_zip').val(contact_obj.zip_code);
    $('.similar_add1, .txtadd1').val((contact_obj.address == undefined?'':contact_obj.address));
    $('.similar_add2, .txtadd2').val((contact_obj.address2 == undefined?'':contact_obj.address2));
    $('.inquery_country, .txtcountry').val((contact_obj.country == undefined?'':contact_obj.country))
  }
}

$(window).ready(function() {
  var li_length = $('.show-p-gallery ul li').length;
  if (li_length % 2 == 0) {
    var length_half = li_length / 2;
//     var length_half_plus = li_length / 2 + 1;
    $('.show-p-gallery ul li:nth-child(-n+'+ length_half+')').wrapAll("<div class='grid-left'></div>");
    $('.show-p-gallery ul li:not(.grid-left li)').wrapAll("<div class='grid-right'></div>");
  } else {
    var length_half = li_length / 2 + 0.5;
//     var length_half_plus = li_length / 2 + 1.5;
    $('.show-p-gallery ul li:nth-child(-n+'+ length_half+')').wrapAll("<div class='grid-left'></div>");
    $('.show-p-gallery ul li:not(.grid-left li)').wrapAll("<div class='grid-right'></div>");
  }
});


/* pintrest style galler (3 columns) for testimonial */
$(document).ready(function() {
  var li_length = Math.round($('.blog-grid li').length/3); /* Previous 3 grid here */
  if(/^((\d+(\\.\d{0,2})?)|((\d*(\.\d{1,2}))))$/.test(li_length)){
    $('.blog-grid li:nth-child(-n + ' + li_length + ')').addClass('left-cell').wrapAll('<div class="column-left"></div>');
    $('.blog-grid li:nth-last-child(-n + ' + li_length + ')').not('.left-cell').addClass('right-cell').wrapAll('<div class="column-right"></div>');
    $('.blog-grid li').not('.left-cell, .right-cell').addClass('center-cell').wrapAll('<div class="column-center"></div>');
  }else{
    var roundValue = li_length.toFixed();
    var roundValueInc = parseInt(roundValue) +  parseInt(1);
    var roundValueDesc = parseInt(roundValue) -  parseInt(1);
    if(li_length > roundValue) {
      $('.blog-grid li:nth-child(-n + ' + roundValueInc + ')').addClass('left-cell').wrapAll('<div class="column-left"></div>');
      $('.blog-grid li:nth-last-child(-n + ' + roundValue + ')').not('.left-cell').addClass('right-cell').wrapAll('<div class="column-right"></div>');
      $('.blog-grid li').not('.left-cell, .right-cell').addClass('center-cell').wrapAll('<div class="column-center"></div>');
    } else {
      $('.blog-grid li:nth-child(-n + ' + roundValue + ')').addClass('left-cell').wrapAll('<div class="column-left"></div>');
      $('.blog-grid li:nth-last-child(-n + ' + roundValueDesc + ')').not('.left-cell').addClass('right-cell').wrapAll('<div class="column-right"></div>');
      $('.blog-grid li').not('.left-cell, .right-cell').addClass('center-cell').wrapAll('<div class="column-center"></div>');
    }
  }
});

/* Artisera promise */
/*$('.f-menu li:nth-child(2)').click(function(){
  var locate_href = $(this).children('a').attr('href');
  locate_href = locate_href.split('/').last();
  console.log(locate_href);
  return false;
  window.location.href = '#';
  locate = window.location.href;
  if(locate.indexOf('#') > -1 ){
    $('html, body').scrollTop($(".story-i-txt.sec-i-right").offset().top - 55 );
    //       $('html, body').animate({
    //         scrollTop: $(".story-i-txt.sec-i-right").offset().top - 75
    //       }, 3000);
  }
});*/


var headHeight  = $("header").innerHeight();

$(document).ready(function() {
  menu();
});

$(window).on('scroll', function(){
  menu();
});
function menu(){
  if($('header').hasClass('is-fixed')){
    $('body').addClass('sticky-opened');
  } else {
    $('body').removeClass('sticky-opened');
  }
}


$('.nav-menu-xs ul li').click(function(){
  console.log('sticky_click');
  $(this).addClass('active').siblings('li').removeClass('active');
  $('body').addClass('menu-opened');
  $('.nav-menu').addClass('sticky-menu');
  $('.nav-menu').addClass('margin-top');
  var currClass= $(this).attr('data-class');
  $('.nav-menu ul li[data-class="'+ currClass +'"]').addClass('submenu-opened').siblings().removeClass('submenu-opened');
  $(".nav-menu").scrollTop(0);
});

// $('.c-mask').click(function(){
//   $('body').removeClass('menu-opened');
//   $('.nav-menu').removeClass('sticky-menu');
// });
